import {Component, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {TieredMenu} from 'primeng/tieredmenu';

@Component({
  selector: 'si-menu-icon',
  templateUrl: './menu-icon.component.html',
  styleUrls: ['./menu-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuIconComponent {
  @Input() menuItems: MenuItem[];
  @Input() tooltip: string;
  @Input() tooltipPosition = 'top';
  @Input() tieredMenuStyles: string;
  @Input() icon = 'icon-menumode1';
  @Input() iconClass: string;
  @ViewChild('menu') menu: TieredMenu;

  constructor() {
  }

  toggleMenu(event: MouseEvent): void {
    this.menu.toggle(event);
  }
}
